import React, { useEffect } from 'react';
import { useReactiveVar } from '@apollo/client';
import { useLocation } from 'react-router-dom';

import { useInMemoryStorage } from '@ocx/data-in-memory-storage';

import { RedirectToRequestLink } from './redirect-to-request-link.component';
import { isLoggedInVar } from './authReactiveVariables';
import { AUTH_RETURN_URL_STORAGE_KEY, AUTH_RETURN_URL_TTL_MS } from './return-url.storage';

export type AuthGuardProps = {
  children: React.ReactNode;
  Unauthorized?: React.ComponentType;
};

export const AuthGuard = ({ children, Unauthorized = RedirectToRequestLink }: AuthGuardProps) => {
  const isLoggedIn = useReactiveVar(isLoggedInVar);
  const { pathname, search, hash } = useLocation();
  const { setStorageValue: setReturnUrl } = useInMemoryStorage<string>(AUTH_RETURN_URL_STORAGE_KEY);

  useEffect(() => {
    if (!isLoggedIn) {
      setReturnUrl(pathname + search + hash, AUTH_RETURN_URL_TTL_MS);
    }
  }, [isLoggedIn, pathname, search, hash, setReturnUrl]);

  if (!isLoggedIn) {
    return <Unauthorized />;
  }
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};
